import { CalendarDots, House, Ticket, Users, Sliders, Invoice } from "@phosphor-icons/react";

const menu = [{
    label: 'Dashboard',
    icon: House,
    href: '/',
},{
    label: 'Prenotazioni',
    icon: CalendarDots,
    href: '/reservations',
},{
    label: 'Fatture',
    icon: Invoice,
    href: '/invoices',
},{
    label: 'Coupon',
    icon: Ticket,
    href: '/coupons',
},{
    label: 'Clienti',
    icon: Users,
    href: '/customers',
    active: '/customers',
},{
    label: 'Impostazioni',
    icon: Sliders,
    href: '/settings',
    active: '/settings'
}]

export default menu;